<app-list2
    *ngIf="listId"
    [listId]="listId"
    [args]="paramsList"
    #list>
</app-list2>
<app-back-button [backButtonOptions]="configurationArguments?.backButtonOptions" *ngIf="configurationArguments?.backButtonOptions?.enableBackButton"></app-back-button>
